<template>
  <div style="margin-left: 20px">
    <lk-card title="个人信息查询" style="margin-top: 20px">
      <div class="cardArea">
        <div class="cardLeft">
          <div class="cardType">卡类型:</div>
          <div>
            <lk-radio-group v-model="cardType">
              <lk-radio
                v-for="item in cardList"
                :key="item.id"
                :label="item.id"
              >
                <span>{{ item.name }}</span>
              </lk-radio>
            </lk-radio-group>
          </div>
        </div>
        <div style="display:flex; align-items:center" class="cardRight" v-if="isNeedPassWord && cardType != 1">
          医保卡密码：<lk-input type="password" style="width:200px" placeholder="请输入医保卡密码" v-model="password"></lk-input>
        </div>
        <div style="display:flex; align-items:center" class="cardRight" v-if='cardType == 1 && ifShowScanNum'>
        电子医保卡：<lk-input style="width:200px" :disabled="healthDisabled" placeholder="请扫码电子医保二维码" v-model="healthNum"></lk-input>
      </div>
        <div class="cardRight">
          <lk-button
            type="primary"
            @click="handleClick"
            :loading="btnCardLoading"
            :disabled="healthDisabled"
            >读卡</lk-button
          >
        </div>
      </div>
      <div class="cardArea">
        <div class="cardLeft" style="margin-left: -10px;height:30px">
          <div class="cardType">人员类型:</div>
          <div>
            <lk-radio-group v-model="personType">
              <lk-radio v-for='item in personTypeList' :key="item.id" :label='item.id'>
                <span>{{item.name}}</span>
              </lk-radio>
            </lk-radio-group>
          </div>
        </div>
      </div>
      <div class="cardInfoCon">
        <div v-for="(item, index) in cardInfo" :key="index" class="everyInfo">
          {{
            `${item.title} : ${
              cardInfoObj[item.key] ? cardInfoObj[item.key] : ""
            }`
          }}
        </div>
      </div>
    </lk-card>
    <lk-card title="修改密码" style="margin-top: 20px">
      <div v-if="changePasIsShowInput">
        <lk-input type='password' style="width:200px" placeholder="请输入旧密码" v-model="oldPassword"></lk-input>
        <lk-input type='password' style="width:200px;margin: 0 20px" placeholder="请输入新密码" v-model="newPassword"></lk-input>
        <lk-input type='password' style="width:200px;margin: 0 20px 0 0" placeholder="请确认新密码" v-model="confirmPass"></lk-input>
      </div>
      <lk-button type='primary' @click="toChangePass" style="margin-top:10px">修改密码</lk-button>
    </lk-card>
    <lk-card title="查询内容" style="margin-top: 20px">
      <lk-form
        :label-width="80"
        :model="formInfo"
        :rules="formValidate"
        ref="form"
      >
        <lk-form-item label="查询类型:" class="inputCon" prop="SearchType">
          <lk-select
            v-model="formInfo.SearchType"
            placeholder="请选择"
            clearable
            @on-change="handleChange"
          >
            <lk-option
              v-for="item in searchTypeList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}</lk-option
            >
          </lk-select>
        </lk-form-item>
        <lk-form-item label="险种类型:" class="inputCon" prop="insType" v-if="isShow">
          <lk-select
            v-model="formInfo.insType"
            placeholder="请选择"
            clearable
            @on-change="handleChange"
          >
            <lk-option
              v-for="item in insTypeList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}</lk-option
            >
          </lk-select>
        </lk-form-item>
        <lk-form-item label="医疗类别:" class="inputCon" prop="medType" v-if="isShow">
          <lk-select
            v-model="formInfo.medType"
            placeholder="请选择"
            clearable
            @on-change="handleChange"
          >
            <lk-option
              v-for="item in medTypeList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}</lk-option
            >
          </lk-select>
        </lk-form-item>
        <lk-form-item label="查询时间:" class="inputCon" prop="times" v-if="isShow">
          <timeStampDatePicker type='daterange' placeholder='请选择' v-model="formInfo.times" style="width: 100%"></timeStampDatePicker>
        </lk-form-item>
        <lk-form-item label="病种编码:" class="inputCon" v-if="isShow">
          <lk-input
            v-model="formInfo.diseaseCode"
            placeholder="请输入"
          ></lk-input>
        </lk-form-item>
        <lk-button
          type="primary"
          @click="handleSearch"
          :loading="serachLoading"
          style="display: inline-block"
          >查询</lk-button
        >
      </lk-form>
    </lk-card>
    <lk-card title="查询结果" style="margin-top: 20px">
      <lk-table border :columns="currentColumns" :data="tableData"></lk-table>
    </lk-card>
  </div>
</template>
<script>
import utils from '../../libs/utils';
import storeUtils from '../../libs/storeUtil';
import healthInsManage from '../../services/healthInsManage';

export default {
  name: 'personalInfo',
  components: {},
  props: {},
  watch: {
    'formInfo.SearchType': {
      handler(val) {
        if (val === 1) {
          this.isShow = true;
          this.formValidate = this.treatmentValidate;
        } else {
          this.isShow = false;
          this.formValidate = {};
        }
      },
    },
  },
  computed: {
    isNeedPassWord() {
      return storeUtils.isNeedPassword(this.$store.state.storeInfo.id);
    },
    changePasIsShowInput() {
      return storeUtils.changePasIsShowInput(this.$store.state.storeInfo.id);
    },
    ifShowScanNum() {
      return this.$store.state.storeInfo.id === 10; // rd: 125，测试：399,396，线上：深圳：62， 佛山：10
    },
  },
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      confirmPass: '',
      password: '',
      isShow: true,
      btnCardLoading: false,
      serachLoading: false,
      personType: 1,
      healthNum: '', // 医保码
      healthDisabled: false,
      personTypeList: [
        {
          id: 1,
          name: '中国大陆',
        },
        {
          id: 2,
          name: '港澳台',
        },
        {
          id: 3,
          name: '外国人',
        },
      ],
      cardType: 3,
      cardList: [
        {
          id: 3,
          name: '医保卡',
        },
        {
          id: 2,
          name: '身份证',
        },
        {
          id: 1,
          name: '电子医保卡',
        },
      ],
      cardInfo: [
        {
          title: '人员编号',
          key: 'psnNo',
        },
        {
          title: '人员姓名',
          key: 'psnName',
        },
        {
          title: '证件类型',
          key: 'psnCertTypeName',
        },
        {
          title: '证件号码',
          key: 'certno',
        },
        {
          title: '性别',
          key: 'gendName',
        },
        {
          title: '民族',
          key: 'natyName',
        },
        {
          title: '出生日期',
          key: 'brdy',
        },
      ],
      cardInfoObj: {},
      searchTypeList: [
        {
          id: 1,
          name: '待遇享受检查',
        },
        {
          id: 2,
          name: '慢特病备案查询',
        },
        {
          id: 3,
          name: '结算信息查询',
        },
      ],
      formInfo: {
        SearchType: 1,
        insType: null,
        medType: null,
        times: [],
        diseaseCode: null,
      },
      insTypeList: [
        {
          id: 310,
          name: '职工基本医疗保险',
        },
        {
          id: 320,
          name: '公务员医疗补助',
        },
        {
          id: 330,
          name: '大额医疗费用补助',
        },
        {
          id: 340,
          name: '离休人员医疗保障',
        },
        {
          id: 390,
          name: '城乡居民基本医疗保险',
        },
        {
          id: 392,
          name: '城乡居民大病医疗保险',
        },
        {
          id: 510,
          name: '生育保险',
        },
      ],
      medTypeList: [],
      formValidate: {},
      treatmentValidate: {
        SearchType: [
          {
            required: true,
            message: '请选择查询类型',
            type: 'number',
            trigger: 'change',
          },
        ],
        insType: [
          {
            required: true,
            message: '请选择险种类型',
            type: 'number',
            trigger: 'change',
          },
        ],
        medType: [
          {
            required: true,
            message: '请选择医疗类别',
            type: 'number',
            trigger: 'change',
          },
        ],
        times: [
          {
            required: true,
            type: 'array',
            message: '请选择时间',
            trigger: 'change',
          },
        ],
      },
      tableData: [],
      currentColumns: [],
      treatmentColumns: [
        {
          type: 'index',
          title: '序号',
          width: 60,
        },
        {
          title: '人员编号',
          key: 'psnNo',
          minWidth: 140,
        },
        {
          title: '待遇检查类型',
          key: 'trtChkTypeName',
          minWidth: 140,
        },
        {
          title: '基金支付类型',
          key: 'fundPayTypeName',
          minWidth: 140,
        },
        {
          title: '基金款项待遇享受标志',
          key: 'trtEnjymntFlagName',
          minWidth: 140,
        },
        {
          title: '开始日期',
          key: 'begndate',
          minWidth: 140,
        },
        {
          title: '结束日期',
          key: 'enddate',
          minWidth: 140,
        },
        {
          title: '待遇检查结果',
          key: 'trtChkRslt',
          minWidth: 140,
        },
      ],
      userDiseaseColumns: [
        {
          type: 'index',
          title: '序号',
          width: 60,
        },
        {
          title: '门慢门特病种目录代码',
          key: 'opspDiseCode',
          minWidth: 140,
        },
        {
          title: '门慢门特病种名称',
          key: 'opspDiseName',
          minWidth: 140,
        },
        {
          title: '开始日期',
          key: 'begndate',
          minWidth: 140,
        },
        {
          title: '结束日期',
          key: 'enddate',
          minWidth: 140,
        },
      ],
      settlementColumns: [
        {
          title: '序号',
          type: 'index',
        },
        {
          title: '人员姓名',
          key: 'psnName',
          minWidth: 116,
        },
        {
          title: '人员证件类型',
          key: 'psnCertTypeName',
          minWidth: 116,
        },
        {
          title: '证件号码',
          key: 'certno',
          minWidth: 116,
        },
        {
          title: '险种类型',
          key: 'insutypeName',
          minWidth: 116,
        },
        {
          title: '人员类别',
          key: 'psnType',
          minWidth: 116,
        },
        {
          title: '公务员标志',
          key: 'cvlservFlag',
          minWidth: 116,
        },
        {
          title: '参保机构医保区划',
          key: 'insuOptins',
          minWidth: 116,
        },
        {
          title: '定点医药机构名称',
          key: 'fixmedinsName',
          minWidth: 116,
        },
        {
          title: '定点归属机构',
          key: 'fixmedinsPoolarea',
          minWidth: 116,
        },
        {
          title: '结算时间',
          key: 'setlTime',
          minWidth: 116,
        },
        {
          title: '就诊凭证类型',
          key: 'mdtrtCertType',
          minWidth: 116,
        },
        {
          title: '医疗类别',
          key: 'medType',
          minWidth: 116,
        },
        {
          title: '清算类别',
          key: 'clrType',
          minWidth: 116,
        },
        {
          title: '清算方式',
          key: 'clrWay',
          minWidth: 116,
        },
        {
          title: '清算经办机构',
          key: 'clrOptins',
          minWidth: 116,
        },
        {
          title: '医疗费总额',
          key: 'medfeeSumamt',
          minWidth: 116,
        },
        {
          title: '全自费金额',
          key: 'fulamtOwnpayAmt',
          minWidth: 116,
        },
        {
          title: '基本医疗保险统筹基金支出',
          key: 'hifpPay',
          minWidth: 116,
        },
        {
          title: '公务员医疗补助基金支出',
          key: 'cvlservPay',
          minWidth: 116,
        },
        {
          title: '企业补充医疗保险基金支出',
          key: 'hifesPay',
          minWidth: 116,
        },
        {
          title: '居民大病保险资金支出',
          key: 'hifmiPay',
          minWidth: 116,
        },
        {
          title: '职工大额医疗费用补助基金支出',
          key: 'hifobPay',
          minWidth: 116,
        }, //
        {
          title: '其他支出',
          key: 'othPay',
          minWidth: 116,
        },
        {
          title: '基金支付总额',
          key: 'fundPaySumamt',
          minWidth: 116,
        },
        {
          title: '个人支付金额',
          key: 'psnPay',
          minWidth: 116,
        },
        {
          title: '个人账户支出',
          key: 'acctPay',
          minWidth: 116,
        },
        {
          title: '现金支付金额',
          key: 'cashPayamt',
          minWidth: 116,
        },
        {
          title: '余额',
          key: 'balc',
          minWidth: 116,
        },
        {
          title: '病种编码',
          key: 'diseCodg',
          minWidth: 116,
        },
        {
          title: '病种名称',
          key: 'diseName',
          minWidth: 116,
        },
        {
          title: '发票号',
          key: 'invono',
          minWidth: 116,
        },
        {
          title: '经办人姓名',
          key: 'opterName',
          minWidth: 116,
        },
        {
          title: '经办时间',
          key: 'optTime',
          minWidth: 116,
        },
      ],
    };
  },
  methods: {
    handleChange() {},
    toChangePass() {
      if (this.changePasIsShowInput) {
        if (!this.oldPassword || !this.newPassword || !this.confirmPass) {
          this.$Message.error('请填写密码');
          return;
        }
        if (this.confirmPass !== this.newPassword) {
          this.$Message.error('两次输入的密码不一致，请重新输入');
          return;
        }
      }
      const param = {
        pass: this.oldPassword,
        newPass: this.newPassword,
        operate: 2, // 1读卡+校验，2改密， 3新增密码
        type: 3, // 医保卡
        medicalSubject: 0, // 省医保1，市医保0
      };
      healthInsManage.readCard(param).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('修改密码成功');
          this.newPassword = '';
          this.confirmPass = '';
          this.oldPassword = '';
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleClick() {
      if (this.cardType == 1 && (this.healthNum == '' || this.healthNum == undefined) && this.ifShowScanNum) {
        this.$Message.error('请填写码电子医保');
        return;
      }
      if (storeUtils.isNeedPassword(this.$store.state.storeInfo.id)) {
        if (!this.password && this.cardType === 3) {
          this.$Message.error('请填写密码');
          return;
        }
        this.handleReadCard();
      } else {
        this.handleReadCard();
      }
    },
    handleReadCard() {
      const obj = {
        type: this.cardType,
        operate: 1,
        pass: this.password,
        personType: this.personType,
        ecToken: this.healthNum,
      };
      this.btnCardLoading = true;
      healthInsManage
        .readCard(obj)
        .then((res) => {
          this.btnCardLoading = false;
          if (res.data.status === 200) {
            this.healthDisabled = true;
            this.$Message.success('读卡成功');
            this.cardInfoObj = res.data.data || {};
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          this.btnCardLoading = false;
          utils.handleError(err);
        });
    },
    handleSearch() {
      this.toFormValidate()
        .then((res) => {
          if (res) {
            let begntime = ''; let endtime = '';
            this.serachLoading = true;
            if (this.formInfo.SearchType === 1) { // 人员待遇享受检查
              if (this.formInfo.times.length) {
                begntime = this.formInfo.times[0];
                endtime = this.formInfo.times[1];
              }
              const param = {
                psnNo: this.cardInfoObj.psnNo || '',
                insutype: this.formInfo.insType,
                medType: this.formInfo.medType,
                begntime,
                endtime,
                diseCodg: this.formInfo.diseaseCode,
              };
              healthInsManage.treatment(param).then((res) => {
                this.serachLoading = false;
                if (res.data.status === 200) {
                  if (!(res.data.data instanceof Array)) {
                    this.$Message.error('返回的数据格式错误');
                    return;
                  }
                  this.tableData = res.data.data;
                  this.currentColumns = this.treatmentColumns;
                } else {
                  this.$Message.error(res.data.error);
                }
              }).catch((err) => {
                this.serachLoading = false;
                utils.handleError(err);
              });
            }
            // 下面是人员慢特病备案信息查询
            if (this.formInfo.SearchType === 2) {
              const param = {
                psnNo: this.cardInfoObj.psnNo || '',
              };
              healthInsManage.getUserDiseaseInfo(param).then((res) => {
                this.serachLoading = false;
                if (res.data.status === 200) {
                  if (!(res.data.data instanceof Array)) {
                    this.$Message.error('返回的数据格式错误');
                    return;
                  }
                  this.tableData = res.data.data;
                  this.currentColumns = this.userDiseaseColumns;
                } else {
                  this.$Message.error(res.data.error);
                }
              }).catch((err) => {
                this.serachLoading = false;
                utils.handleError(err);
              });
            }
            // 下面是人员慢特病备案信息查询
            if (this.formInfo.SearchType === 3) {
              const params = {
                psnNo: this.cardInfoObj.psnNo || '',
              };
              healthInsManage.getSettleInfos(params).then((result) => {
                this.serachLoading = false;
                if (result.data.status === 200) {
                  if (!(result.data.data instanceof Array)) {
                    this.$Message.error('返回的数据格式错误');
                    return;
                  }
                  this.tableData = result.data.data;
                  this.currentColumns = this.settlementColumns;
                } else {
                  this.$Message.error(result.data.error);
                }
              }).catch((err) => {
                this.serachLoading = false;
                utils.handleError(err);
              });
            }
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    toFormValidate() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          if (!valid) {
            this.$Message.error('请按照要求填写');
            resolve(false);
          } else {
            resolve(true);
          }
        });
      });
    },
    getMedTypeList() {
      healthInsManage.getMedTypeList().then((res) => {
        if (res.data.status === 200) {
          this.medTypeList = res.data.data || [];
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.currentColumns = this.treatmentColumns;
    this.formValidate = this.treatmentValidate;
    this.getMedTypeList();
  },
};
</script>
<style lang="less" scoped>
.cardArea {
  height: 60px;
  display: flex;
  align-items: center;
  .cardLeft {
    display: flex;
    .cardType {
      margin: 0 20px;
    }
  }
  .cardRight {
    margin-left: 60px;
  }
}
.cardInfoCon {
  width: 90%;
  padding-left: 50px;
  .everyInfo {
    width: 30%;
    display: inline-block;
    margin-top: 10px;
  }
}
.inputCon {
  width: 30%;
  display: inline-block;
  margin-right: 20px;
}
</style>
